module.exports = __webpack_public_path__ + "9727a084e1a32aeded3a738c81a54578.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-basketball.png
// module id = 2467
// module chunks = 0